<template>
  <div>
    <p>
      🤩 מעוניינים להגיש מועמדות? 🤩
      <br>
      להגשת מועמדות >> {{position_link}}
      <br>
      <br>
      ⭐ להגשת מועמדות באמצעות המייל: שלחו אלינו (בציון מספר משרה {{ $utils.getPositionApplicantCode(position.id) }}) את קורות החיים שלכם וספרו לנו בשפה חופשית על עצמכם ועל התאמתכם למשרה – כדאי לפרט ולהרחיב!
      <br>
      המייל שלנו: hr@suitup.co.il
      <br>
      <br>
      ⭐ אפליקציית suitup - לצפייה במשרות ולבניית פרופיל ללא עלות: www.suitup.website (אפשר גם בדיסקרטיות 😎)
      <br>
      <br>
      ⭐ לצפייה במשרות חמות לעורכי דין ויועצים משפטיים: https://www.suitup.co.il/positions
      <br>
      <br>
      ⭐ מומלץ לעקוב אחרינו 👍 בעמוד הפייסבוק שלנו לקבלת עדכונים חמים, תכנים מקצועיים וטיפים לחיפוש עבודה: https://www.facebook.com/suitup.co.il
      <br>
      <br>
      ⭐ ללינקדאין שלנו: https://www.linkedin.com/in/reut-kaplan-rosenthal-adv
      <br>
      <br>
      ⭐ לטלגרם שלנו: https://t.me/+3eUQ4QFAWCU0MWY0
      <br>
    </p>
  </div>
</template>
<script>
export default {
  name: 'suitup-footer',
  props: ['position', 'position_link']
}
</script>
